import { useState, useEffect, useRef } from "react";
import { Newspaper, Lightning, Warning } from "@phosphor-icons/react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsTicker() {
  const [tickerItems, setTickerItems] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    async function fetchTickerData() {
      try {
        const resp = await axios.get(`${API}/ticker`);
        setTickerItems(resp.data.items || []);
      } catch {
        setTickerItems([]);
      }
    }
    fetchTickerData();
    const interval = setInterval(fetchTickerData, 60000); // refresh every 60s
    return () => clearInterval(interval);
  }, []);

  if (tickerItems.length === 0) return null;

  // Duplicate items for seamless loop
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#0c0c0c] border-t border-white/10" data-testid="news-ticker">
      {/* Ticker label */}
      <div className="flex items-stretch h-9">
        <div className="flex-shrink-0 flex items-center gap-1.5 px-3 bg-[#FF3B30] z-10">
          <Lightning size={14} weight="fill" className="text-white" />
          <span className="text-[11px] font-bold tracking-widest uppercase text-white whitespace-nowrap">
            BREAKING NEWS
          </span>
        </div>

        {/* Scrolling content */}
        <div className="flex-1 overflow-hidden relative">
          <div className="ticker-scroll flex items-center h-9 whitespace-nowrap" ref={scrollRef}>
            {doubled.map((item, idx) => (
              <span key={idx} className="inline-flex items-center gap-3 px-6">
                {item.type === "alert" ? (
                  <Warning size={12} weight="fill" className="text-[#FF3B30] flex-shrink-0" />
                ) : item.type === "score" ? (
                  <span className="w-1.5 h-1.5 rounded-full bg-[#34C759] flex-shrink-0" />
                ) : (
                  <Newspaper size={12} weight="fill" className="text-[#007AFF] flex-shrink-0" />
                )}
                {item.league && (
                  <span className="text-[10px] font-bold tracking-widest uppercase text-[#007AFF]">{item.league}</span>
                )}
                <span className="text-xs text-white/80">{item.text}</span>
                <span className="text-white/10 mx-2">|</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
